import { Any, userFacingMessages } from "@cede/types";
import { CedeSDKError } from "../errors";

/**
 * Get the error message from an error. Used in the UI to display the error to the user.
 */
export const getErrorMessage = (error: Any, defaultMessage = userFacingMessages.UNKNOWN_ERROR): string => {
  if (error instanceof CedeSDKError) {
    return error.message;
  }

  if (error?.message) {
    return error.message;
  }

  return defaultMessage;
};
